import type { FaireProductEntity } from "../../entity_types/product";

export const p_jb46qyn9v8: FaireProductEntity = {
  token: "p_jb46qyn9v8",
  type: "product",
  name: "One Fish Two Fish 3D Book Display Building Kit",
  brandToken: "b_u6s27vxprc",
  brandName: "Brickcraft",
  imageUrl:
    "https://cdn.faire.com/fastly/fe80a183f32c75712bcf2758f1f33024b31eb35d430e5485aafe503154ea572b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c4ddfe2d9a85a86cc8640eee882d54a7cd518b59e4d41917d16e784e7a5c7137.jpeg",
    "https://cdn.faire.com/fastly/2b5f86adabe93f09aea0a4b644fcb3e5ff32a97d8e7ecf8a4dc3182c3baebfd6.jpeg",
    "https://cdn.faire.com/fastly/c0dc4de4c8bc78da38aa0172baab405f729a5bea08f4560b22944721129f97b1.jpeg",
    "https://cdn.faire.com/fastly/3365ff33b6c12d2d9a1a5bf926bea80d2b4d23e54c77ed81b7f76a41323d9193.jpeg",
    "https://cdn.faire.com/fastly/c08cb49cf35f2bb478530198845ebc657b32974092e71c171b67293960888703.jpeg",
    "https://cdn.faire.com/fastly/e83b830196c6dbbf8d09abbdeaecf314551bf88871bf2bd2b13c957bc855ad51.jpeg",
    "https://cdn.faire.com/fastly/0c44c78a863b0d5684d6044122e9363ac0a9a421c0bc19535517340c0543c8d7.jpeg",
  ],
  priceDollars: 27.56,
  description:
    "Red Fish and Blue Fish take the spotlight in this bright and buildable brick book! The cover features two 3D fish figures in bold colors, while the inside includes printed rhymes and a blank page you can decorate with playful stickers featuring classic rhymes and characters. Packed with Seuss style and perfect for display, this set is one of four collectible builds in the Dr. Seuss series.",
  tags: [],
  msrpDollars: 55.12,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-21T22:11:56.001Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
